import { EMailTemplateType, INotificationTemplateDto } from "@kuika/kuika-cl-model";
import * as React from "react";
import { KuikaListTableRowAction } from "../../ui-kit/kuika-list-table/kuika-list-table";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";

/**
 * What can be done to an email template from a list of them: the landing table's row menu and
 * the editor switcher's "…" are this one list. System templates (reset password and friends)
 * offer nothing — they belong to the platform, not the project.
 */

export const isSystemEmailTemplate = (template: INotificationTemplateDto): boolean =>
  template.templateStatus !== EMailTemplateType.Default;

export interface IEmailTemplateRowActionHandlers {
  onDuplicate: (template: INotificationTemplateDto) => void;
  /** Opens the host's confirmation; nothing is deleted until it is answered. */
  onRequestDelete: (template: INotificationTemplateDto) => void;
}

export const buildEmailTemplateRowActions = (
  handlers: IEmailTemplateRowActionHandlers
): KuikaListTableRowAction<INotificationTemplateDto>[] => [
  {
    key: "duplicate",
    label: "Duplicate",
    icon: <KuikaSvg width={16} height={16} name="copy" />,
    hidden: isSystemEmailTemplate,
    onSelect: handlers.onDuplicate
  },
  {
    key: "delete",
    label: "Delete",
    icon: <KuikaSvg width={16} height={16} name="trash" />,
    danger: true,
    hidden: isSystemEmailTemplate,
    onSelect: handlers.onRequestDelete
  }
];
